import { GROUP_REQUIREMENT_REF_PREFIX } from './requirementRef.util'

// Mirrors backend/src/lambdas/service/hub/microsoft/groupRequirements/groupRequirementUtils.js's
// sentinel format: a "group:<requirementId>" string diverts a group-bearing field into automatic
// resolution at deploy time, alongside literal Graph group GUIDs.
export const REQUIREMENT_REF_PREFIX = GROUP_REQUIREMENT_REF_PREFIX

export const isRequirementRef = (value) => typeof value === 'string' && value.startsWith(REQUIREMENT_REF_PREFIX)

export const getRequirementId = (value) => (isRequirementRef(value) ? value.slice(REQUIREMENT_REF_PREFIX.length) : null)

export const toRequirementRef = (requirementId) => `${REQUIREMENT_REF_PREFIX}${requirementId}`

// Mirrors backend/src/lambdas/service/hub/microsoft/groupRequirements/resolveGroupRequirements.js's
// RESOLUTION_STATUS — the preview endpoint's response is the one place these values cross the
// wire, so both status-driven UIs (the resolution summary and the deploy-gating check) key off
// this shared vocabulary instead of independently duplicating the same magic strings.
export const GROUP_REQUIREMENT_STATUS = {
  MATCHED: 'matched',
  CREATABLE: 'creatable',
  MULTI_MATCH: 'multiMatch',
  UNRESOLVABLE: 'unresolvable',
}
